module.exports = __webpack_public_path__ + "media/images/flags/16/Tuvalu-ac0f705e0c9b3a050039ca8261a1c66b.png";